<template>
  <b-card title="جزییات:">
    <b-row>
      <b-col cols="12" sm="4" md="4">
        <b-form-group label="تاریخ ثبت:">
          <div class="form-control">
            {{ incomDetails.created_at | moment("jYYYY-jM-jD HH:mm:ss") }}
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="4" md="4">
        <b-form-group label="تاریخ ارسال به بانک:">
          <div class="form-control">
            {{
              incomDetails.tracking_number == null
                ? "انجام نشده"
                : incomDetails.updated_at | moment("jYYYY-jM-jD HH:mm:ss")
            }}
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="4" md="4">
        <b-form-group label="مبلغ:">
          <div class="form-control">
            {{
              incomDetails.amount != null
                ? (-1 * incomDetails.amount).toLocaleString()
                : 0
            }}
            ریال
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="4" md="4">
        <b-form-group label="نام صاحب حساب مقصد:">
          <div class="form-control">
            {{
              incomDetails.user && incomDetails.user.name != null
                ? incomDetails.user.name
                : null
            }}
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="4" md="4">
        <b-form-group label="شماره شبا مقصد:">
          <div class="form-control">
            {{
              incomDetails.sattlement_iban &&
              incomDetails.sattlement_iban != null
                ? incomDetails.sattlement_iban
                : null
            }}
          </div>
        </b-form-group>
      </b-col>

      <b-col cols="12" sm="4" md="4">
        <b-form-group label="وضعیت تراکنش:">
          <div class="form-control">
            {{
              incomDetails.tracking_number !== null ? "انجام شده" : "انجام نشده"
            }}
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="4" md="4">
        <b-form-group label="کد رهگیری تراکنش:">
          <div class="form-control">
            {{ incomDetails.tracking_number }}
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" sm="2" md="2" class="mt-2">
        <b-button
          block
          @click="showModal = true"
          variant="success"
          v-b-modal.modal-2
          :class="isBusySheba ? 'spinner spinner-light spinner-right' : ''"
          >پرداخت</b-button
        >
      </b-col>
      <b-col cols="12" sm="2" md="2" class="mt-2">
        <b-button block variant="danger" @click="$router.push('/identifier')"
          >بازگشت</b-button
        >
      </b-col>
    </b-row>

    <b-modal id="modal-2" title="اطلاعات پرداخت" v-model="showModal">
      <b-row>
        <b-col>
          <b-form-group label="کد رهگیری تراکنش:">
            <b-form-input v-model="tracking_number"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            size="md"
            class="float-right"
            @click="sendRequest"
          >
            ثبت تسویه
          </b-button>
        </div>
      </template>
    </b-modal>
  </b-card>
</template>

<script>
import httpHelper from "../../../helpers/httpHelper";
export default {
  name: "sharingDetails",
  data() {
    return {
      showModal: false,
      selected: null,
      wage: null,
      sharingDetail: {},
      size: "w-25",
      height: "h-50",
      show: false,
      id: this.$route.params.id,
      isBusyTransaction: false,
      isBusySheba: false,
      isBusy: false,
      isBusy2: false,
      modalSheba: "",
      transfer_id: null,
      showbtn: false,
      tracking_number: null,

      incomDetails: {},
    };
  },
  created() {},
  mounted() {
    this.getDetails();
  },
  methods: {
    getDetails() {
      let id = this.$route.params.id;
      httpHelper.getData("~ref/api/v1/income/" + id).then((res) => {
        this.incomDetails = res.result;
      });
    },
    sendRequest() {
      let id = this.$route.params.id;
      httpHelper.setAuth();
      httpHelper
        .postData("~ref/api/v1/income/save-settlement/" + id, {
          tracking_number: this.tracking_number,
        })
        .then((res) => {
          this.getDetails();
          this.showModal = false;
          this.tracking_number = '';
        });
      // this.$store
      //   .dispatch(PAY_PURCENT, {
      //     id: this.loadedDetailsIdentifier.id,
      //     detail_id: this.selected,
      //     tracking_number: this.tracking_number,
      //   })
      //   .then((data) => {
      //     if (data.success == true) {
      //       this.getDetails();
      //       this.showModal = false;
      //       this.$makeToast(
      //         "success",
      //         "ذخیره موفق",
      //         "ذخیره اطلاعات با موفقیت انجام شد.",
      //         5000
      //       );
      //     } else {
      //       this.$makeToast(
      //         "danger",
      //         "ذخیره موفق",
      //         "ذخیره اطلاعات با موفقیت انجام نشد.",
      //         5000
      //       );
      //     }
      //   });
    },

    close() {
      this.show = false;
    },
  },
};
</script>

<style></style>
